<template>
  <g>
    <path
      d="M2.81002 2.81017C2.42002 2.42017 1.79002 2.42017 1.40002 2.81017C1.00002 3.20017 1.00002 3.83017 1.39002 4.22017L9.58002 12.4102L6.58002 15.4202C6.21002 15.8002 6.00002 16.3102 6.00002 16.8402V20.0002C6.00002 21.1002 6.90002 22.0002 8.00002 22.0002H16C16.86 22.0002 17.58 21.4602 17.87 20.7002L19.78 22.6102C20.17 23.0002 20.8 23.0002 21.19 22.6102C21.58 22.2202 21.58 21.5902 21.19 21.2002L2.81002 2.81017ZM16 19.0002C16 19.5502 15.55 20.0002 15 20.0002H9.00002C8.45002 20.0002 8.00002 19.5502 8.00002 19.0002V16.5002L10.84 13.6602L16 18.8302V19.0002Z"
    />
    <path
      d="M8 5.00018C8 4.45018 8.45 4.00018 9 4.00018H15C15.55 4.00018 16 4.45018 16 5.00018V7.50018L13.16 10.3402L14.41 11.5902L17.41 8.60018C17.79 8.22018 18 7.71018 18 7.18018V4.00018C18 2.89018 17.1 2.00018 16 2.00018H8C7.14 2.00018 6.42 2.54018 6.13 3.30018L8 5.17018V5.00018Z"
    />
  </g>
</template>
